__turbopack_context__.v({
  "companyInfo": "nC9aWW_companyInfo",
  "copyright": "nC9aWW_copyright",
  "footer": "nC9aWW_footer",
  "gradientText": "nC9aWW_gradientText",
  "links": "nC9aWW_links",
  "logo": "nC9aWW_logo",
  "portfolio": "nC9aWW_portfolio",
  "social": "nC9aWW_social",
  "subscribe": "nC9aWW_subscribe",
});
